module.exports = __webpack_public_path__ + "img/look12.46af65b4.png";